import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const variantClasses = {
  primary: 'bg-primary text-white hover:bg-teal-600',
  secondary: 'border border-primary text-black hover:bg-gray-600',
  success: 'bg-success text-white hover:bg-green-700',
  danger: 'bg-danger text-white hover:bg-red-700',
  warning: 'bg-warning text-black hover:bg-yellow-500',
  link: 'bg-transparent text-primary hover:bg-teal-400/10 hover:border hover:border-teal-400 shadow-none px-2',
}

const sizeClasses = {
  small: 'text-xs px-4 py-2',
  medium: 'text-base px-4 py-2',
  large: 'text-lg px-8 py-4',
}

const Button = forwardRef(
  ({ children, variant = 'primary', size = 'medium', onClick, disabled, className, ...props }, ref) => {
    const baseClasses =
      'inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 select-none shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 active:translate-y-px disabled:opacity-60 disabled:cursor-not-allowed'

    return (
      <button
        ref={ref}
        className={clsx(baseClasses, variantClasses[variant], sizeClasses[size], className)}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default Button
